import React, { useState, useEffect } from "react";
import {
  Input,
  Form,
  Col,
  Row,
  Button,
  Checkbox,
  Select,
  notification,
} from "antd";
import { PlusOutlined } from "@ant-design/icons";
import RequestHandler from "util/RequestHandler";
import { defaultValidateMessages } from "./Helper";
import ParaticPhoneInput from "./Helper/ParaticPhoneInput";
import { odata } from "../Filters/Helper";

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 8,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 16,
    },
  },
};

const SubFirmUpdateForm = (props) => {
  const [loading, setLoading] = useState(false);
  const [firmSelect, setFirmSelect] = useState({
    data: [],
    loading: false,
  });
  const [form] = Form.useForm();
  const [selectedFirmIds, setSelectedFirmIds] = useState([]);

  useEffect(() => {
    if (props.data) {
      props.data.mobilePhone = props.data.mobilePhone
        ? "90" + props.data.mobilePhone
        : "90";
      form.setFieldsValue(props.data);
      getFirms();
      setSelectedFirmIds(props.data.firmIds);
    }
  }, [props.data]);

  const onFirmSeach = (value) => {
    if (value.length >= 2) {
      setFirmSelect({ ...firmSelect, loading: true });

      RequestHandler.get(
        `/Firm?&$select=id,firmBranchNumber,name&$filter=${odata.contains(
          "name",
          value
        )} or ${odata.contains("firmBranchNumber", value)}`
      ).then((res) => {
        setFirmSelect({ data: res.value, loading: false });
      });
    } else {
      setFirmSelect({ data: [], loading: false });
    }
  };

  const onFinish = (values) => {
    if (selectedFirmIds.length === 0) {
      notification["error"]({
        message: "Lütfen Bayi seçiniz.",
        duration: 3,
      });
      setLoading(false);
      return;
    }

    values.mobilePhone = values.mobilePhone.trim();

    if (values.mobilePhone?.length !== 12 && !isNumeric(values.mobilePhone)) {
      values.mobilePhone = null;
    }

    if (values.mobilePhone === "90") {
      values.mobilePhone = null;
    }

    values.firmIds = selectedFirmIds;
    RequestHandler.put(`/SubFirm`, values)
      .then((response) => {
        setLoading(false);
        if (response?.success) {
          form.resetFields();
          if (props.onSuccess) props.onSuccess();
        }
      })
      .catch(function (error) {
        setLoading(false);
      });
  };

  const onFinishFailed = (errorInfo) => {
    setLoading(false);
  };

  const handleChange = (values) => {
    setSelectedFirmIds(values);
  };

  const maxLengthCheck = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(
        0,
        object.target.maxLength
      );
    }
  };

  const getFirms = () => {
    setFirmSelect({
      ...firmSelect,
      loading: true,
    });
    RequestHandler.get(
      `/Firm?$select=id,firmBranchNumber,name&$filter=id in (${props.data.firmIds})`
    ).then((response) => {
      setFirmSelect({
        data: response.value,
        loading: false,
      });
    });
  };

  function isNumeric(str) {
    return /^\d+$/.test(str);
  }

  return (
    <Form
      {...formItemLayout}
      validateMessages={defaultValidateMessages}
      form={form}
      name="subFirmUpdate"
      initialValues={{
        remember: true,
      }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Row>
        <Col span={24}>
          <Form.Item name="id" hidden>
            <Input />
          </Form.Item>
          <Form.Item label="Ünvan" name="name" rules={[{ required: true }]}>
            <Input />
          </Form.Item>

          <Form.Item
            label="Alt Bayi Kodu"
            name="subFirmBranchNumber"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Vergi Numarası"
            name="vkn"
            rules={[
              {
                min: 10,
                max: 10,
                message: "Vergi Numarası 10 karakter olmalıdır.",
              },
            ]}
          >
            <Input
              type="number"
              onKeyDown={(evt) => evt.key === "e" && evt.preventDefault()}
              maxLength="10"
              onInput={maxLengthCheck}
            />
          </Form.Item>
          <Form.Item
            label="T.C. Kimlik No "
            name="tcNo"
            rules={[
              {
                min: 11,
                message: "TcNo 11 karakter olmalıdır.",
              },
            ]}
          >
            <Input
              type="number"
              onKeyDown={(evt) => evt.key === "e" && evt.preventDefault()}
              maxLength="11"
              onInput={maxLengthCheck}
            />
          </Form.Item>

          <Form.Item
            label="E-Posta"
            name="email"
            rules={[{ required: true, type: "email" }]}
          >
            <Input />
          </Form.Item>

          <Form.Item label="Şifre" name="password">
            <Input.Password autoComplete="new-password" />
          </Form.Item>

          <Form.Item label="Telefon Numarası" name="mobilePhone">
            <ParaticPhoneInput />
          </Form.Item>

          <Form.Item label="Ana Bayiler" name="firmIds">
            <Select
              mode="multiple"
              allowClear
              showSearch
              placeholder="Seçiniz"
              onSearch={onFirmSeach}
              filterOption={(input, option) =>
                option.children
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
              }
              loading={firmSelect.loading}
              onChange={handleChange}
              value={selectedFirmIds}
            >
              {firmSelect.data.map((item) => (
                <Select.Option key={item.id} value={item.id}>
                  {item.name + " " + "(" + item.firmBranchNumber + ")"}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>
      <Row justify="space-between">
        <Col></Col>
        <Col>
          <Button
            type="primary"
            icon={<PlusOutlined />}
            htmlType="submit"
            onClick={() => setLoading(true)}
            loading={loading}
          >
            Güncelle
          </Button>
        </Col>
      </Row>
    </Form>
  );
};
export default SubFirmUpdateForm;
